/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Item_AddInputs */

const vi_pdc_item_add = /** @type {(inputs: Pdc_Item_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm dòng`)
};

/**

* @param {Pdc_Item_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_item_add = /** @type {((inputs?: Pdc_Item_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Item_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_item_add(inputs)
});